// location.noLocationFound
// location.{opt.name} (dynamisch, z.B. location.general, location.files, location.map, location.components)
// location.noDataAvailable
// location.general
// location.files
// location.components
// location.map

export const _translations = {
	legacy: false, // using the Composition API
	locale: 'de', // default locale; you can change this as needed
	messages: {
		de: {
			location: {
				general: 'Allgemein',
				files: 'Dateien',
				map: 'Karte',
				components: 'Komponenten',
				alertGraphs: 'Alarm-Grafiken',
				noLocationFound: 'Kein Standort gefunden',
				noDataAvailable: 'Keine Daten verfügbar',
				name: 'Name',
				location: 'Standort',
				assignedProject: 'Zugewiesenes Projekt',
				comments: 'Kommentare',
				deleteLocation: 'Standort löschen',
				delete: 'Löschen',
				filter: 'Standorte filtern...',
				AllLocations: 'Alle Standorte',
				addNew: 'Neuen Standort hinzufügen',
				status: 'Status',
				pin: '',
				project: 'Projekt',
				lastOnline: 'Zuletzt online',
				hubs: 'Hubs',
				comapps: 'ComApps',
				dashboardGraphs: 'Dashboard-Graphen',
				graphsInDevelopment: 'Graphen-Ansicht noch In Entwicklung',
				archived: 'Archiviert',
				// Added missing translations
				Update: 'Aktualisieren',
				Locations: 'Standorte',
				hidden: 'versteckt',
				lastLog: 'letztes Log',
				filesPerMonth: 'Dateien/Monat',
				save: 'Speichern',
				locationDeleted: 'Standort erfolgreich gelöscht',
				locationUpdated: 'Standort erfolgreich aktualisiert',
				addNewLocation: 'Neuen Standort hinzufügen',
				dashboard: 'Dashboard',
				assignHub: 'Hub zuweisen',
				assignComapp: 'ComApp zuweisen',
				assignDevices: 'Hubs & ComApps zuweisen',
				assignHint: 'Zuweisung verschiebt das Gerät zu diesem Standort.',
				selectHub: 'Hub auswählen',
				selectComapp: 'ComApp auswählen',
				assign: 'Zuweisen',
				unassigned: 'Nicht zugewiesen',
				assignedTo: 'Zugewiesen: {name}',
				hubAssigned: 'Hub zugewiesen',
				comappAssigned: 'ComApp zugewiesen',
				assignFailed: 'Zuweisung fehlgeschlagen',
				noAssignableHubs: 'Keine Hubs verfügbar',
				noAssignableComapps: 'Keine ComApps verfügbar',
				assignedHubs: 'Zugewiesene Hubs',
				assignedComapps: 'Zugewiesene ComApps',
				noAssignedHubs: 'Keine Hubs zugewiesen',
				noAssignedComapps: 'Keine ComApps zugewiesen',
				unassign: 'Zuweisung entfernen',
				unassignConfirm: '{name} wirklich entfernen?',
				hubUnassigned: 'Hub entfernt',
				comappUnassigned: 'ComApp entfernt',
				deletedLocation: 'gelöschter Standort',
				orphanedTitle: 'Verwaiste Zuweisungen',
				orphanedHint: 'Geräte, deren zugeordneter Standort nicht mehr existiert. Hierher verschieben oder Zuweisung entfernen.',
				assignToHere: 'Hierher verschieben',
				assignToHereConfirm: '{name} wirklich nach „{location}" verschieben?',
				applyAndClose: 'Schließen',
				searchPlaceholder: 'Suchen…',
				noSearchMatch: 'Keine Treffer',
			},
		},
		en: {
			location: {
				general: 'General',
				files: 'Files',
				map: 'Map',
				components: 'Components',
				alertGraphs: 'Alert Graphs',
				noLocationFound: 'No location found',
				noDataAvailable: 'No data available',
				name: 'Name',
				location: 'Location',
				assignedProject: 'Assigned Project',
				comments: 'Comments',
				deleteLocation: 'Delete Location',
				delete: 'Delete',
				filter: 'Filter locations...',
				AllLocations: 'All Locations',
				addNew: 'Add location',
				status: 'Status',
				pin: '',
				project: 'Project',
				lastOnline: 'Last online',
				hubs: 'Hubs',
				comapps: 'ComApps',
				dashboardGraphs: 'Dashboard Graphs',
				graphsInDevelopment: 'Graph view still in development',
				archived: 'Archived',
				// Added missing translations
				Update: 'Update',
				Locations: 'Locations',
				hidden: 'hidden',
				lastLog: 'last log',
				filesPerMonth: 'files/month',
				save: 'Save',
				locationDeleted: 'Location successfully deleted',
				locationUpdated: 'Location successfully updated',
				addNewLocation: 'Add New Location',
				dashboard: 'Dashboard',
				assignHub: 'Assign Hub',
				assignComapp: 'Assign ComApp',
				assignDevices: 'Assign hubs & ComApps',
				assignHint: 'Assignment moves the device to this location.',
				selectHub: 'Select a hub',
				selectComapp: 'Select a ComApp',
				assign: 'Assign',
				unassigned: 'Unassigned',
				assignedTo: 'Assigned to {name}',
				hubAssigned: 'Hub assigned',
				comappAssigned: 'ComApp assigned',
				assignFailed: 'Assignment failed',
				noAssignableHubs: 'No hubs available',
				noAssignableComapps: 'No ComApps available',
				assignedHubs: 'Assigned hubs',
				assignedComapps: 'Assigned ComApps',
				noAssignedHubs: 'No hubs assigned',
				noAssignedComapps: 'No ComApps assigned',
				unassign: 'Unassign',
				unassignConfirm: 'Remove {name} from this location?',
				hubUnassigned: 'Hub unassigned',
				comappUnassigned: 'ComApp unassigned',
				deletedLocation: 'deleted location',
				orphanedTitle: 'Orphaned assignments',
				orphanedHint: 'Devices whose assigned location no longer exists. Move them here or remove the assignment.',
				assignToHere: 'Move here',
				assignToHereConfirm: 'Move {name} to "{location}"?',
				applyAndClose: 'Close',
				searchPlaceholder: 'Search…',
				noSearchMatch: 'No matches',
			},
		},
	},
}
